import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'

import Layout from '../../components/Layout'
import { MetaData } from '../../components/common/meta'
import Listing from '../../components/Listing'
import Pagination from '../../components/Pagination'

function Blog({ data, location, pageContext }) {
  const page = data.ghostTag
  const tags = data.allGhostTag.nodes
  const posts = data.allGhostPost.nodes
  const { prevPagePath, nextPagePath, archive } = pageContext

  return (
    <>
      <MetaData location={location} title="Blog" type="website" />
      <Layout>
        <article className="page type-page status-publish hentry">
          <div
            className="et_pb_section no-bottom-padding"
            style={{ backgroundColor: '#ffffff' }}
          >
            <div className="et_pb_row">
              <div className="et_pb_column et_pb_column_4_4">
                <div className="et_pb_text et_pb_bg_layout_light et_pb_text_align_left">
                  <h1>The Affio Blog</h1>
                  <p>{page.description}</p>
                </div>
                <hr
                  className="et_pb_space et_pb_divider"
                  style={{ borderColor: '#cecece' }}
                />
              </div>
            </div>
          </div>
          <div className="et_pb_section">
            <div className="et_pb_row">
              <div className="et_pb_column et_pb_column_3_4">
                <div className="et_pb_text et_pb_bg_layout_light et_pb_text_align_left">
                  <h2>Recent Articles</h2>
                </div>
                <div className="et_pb_posts et_pb_bg_layout_light">
                  <Listing posts={posts} />
                </div>
                <Pagination prev={prevPagePath} next={nextPagePath} />
              </div>
              <div className="et_pb_column et_pb_column_1_4">
                <div className="et_pb_widget_area et_pb_widget_area_right clearfix et_pb_bg_layout_light">
                  <div className="et_pb_widget widget_categories">
                    <h4 className="widgettitle">Article Topics</h4>
                    <ul>
                      {tags.map((tag) => (
                        <li key={tag.slug} className="cat-item cat-item-42">
                          <a href={`/tag/${tag.slug}`}>{tag.name}</a>&nbsp;(
                          {tag.postCount})
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="et_pb_widget widget_archive">
                    <h4 className="widgettitle">Past Articles By Month</h4>
                    <ul>
                      {archive.map(({ slug, name, postCount }) => (
                        <li key={slug}>
                          <Link to={`/${slug}`}>{name}</Link>&nbsp;(
                          {postCount})
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </Layout>
    </>
  )
}

Blog.propTypes = {
  data: PropTypes.shape({
    ghostTag: PropTypes.shape({
      description: PropTypes.string.isRequired,
    }).isRequired,
    allGhostTag: PropTypes.shape({
      nodes: PropTypes.arrayOf(
        PropTypes.shape({
          slug: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
          postCount: PropTypes.number.isRequired,
        }),
      ),
    }).isRequired,
    allGhostPost: PropTypes.shape({
      // eslint-disable-next-line react/forbid-prop-types
      nodes: PropTypes.arrayOf(PropTypes.object),
    }),
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  pageContext: PropTypes.shape({
    prevPagePath: PropTypes.string,
    nextPagePath: PropTypes.string,
    archive: PropTypes.arrayOf(
      PropTypes.shape({
        slug: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        postCount: PropTypes.number.isRequired,
      }),
    ).isRequired,
  }).isRequired,
}

export default Blog
